import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DesktopLoginScreen } from '@/screens/DesktopLoginScreen';

const desktopLoginParamsSchema = z.object({
  state: z.string().optional(),
  code_verifier: z.string().optional(),
  code: z.string().optional(),
  error: z.string().optional(),
  error_description: z.string().optional(),
  email: z.string().optional(),
  login_attempt: z.string().optional(),
});

export const Route = createFileRoute('/desktop-login')({
  component: DesktopLoginScreen,
  validateSearch: (search) => desktopLoginParamsSchema.parse(search),
});
